<div class="complete-page">
  <div class="complete-page-inner">
    <svg-icon [fontSize]="'80px'" [key]="'check'"></svg-icon>
    @if(isDraft){
      <h2>{{'ReceiptCompletePage_CompletePageDraft_Description' | NTSTranslate}}</h2>
    }
    @if(isUpdate){
      <h2>{{'ReceiptCompletePage_CompletePageUpdate_Description' | NTSTranslate}}</h2>
    }
    @if(!isDraft && !isUpdate){
      <h2>{{'ReceiptCompletePage_CompletePageNew_Description' | NTSTranslate}}</h2>
    }
    <nts-filled-button (onClicked)="goToDashboard()" [label]="'ReceiptCompletePage_GoToReceipt' | NTSTranslate">
    </nts-filled-button>
  </div>
</div>
